export default __webpack_public_path__ + "static/media/JuliaV.4bf43597.jpg";